const rightSidebarDrawers = {
  summary: "summary",
  comments: "comments"
};

export default rightSidebarDrawers;
